module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-breadcrumb', {
    staticClass: "bread",
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("微页面管理")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.toCreate()
      }
    }
  }, [_vm._v("\n        创建微页面\n    ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-select', {
    staticClass: "m-1",
    attrs: {
      "placeholder": "机器编号"
    },
    on: {
      "change": function($event) {
        _vm.getData()
      }
    },
    model: {
      value: (_vm.kioskNo),
      callback: function($$v) {
        _vm.kioskNo = $$v
      },
      expression: "kioskNo"
    }
  }, [_c('el-option', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.getcookie('storeId') == 'store001'),
      expression: "this.getcookie('storeId')=='store001'"
    }],
    attrs: {
      "label": "K1-A112",
      "value": "K1-A112"
    }
  }, [_vm._v("K1-A112")]), _vm._v(" "), _c('el-option', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.getcookie('storeId') == 'store001'),
      expression: "this.getcookie('storeId')=='store001'"
    }],
    attrs: {
      "label": "K1-A113",
      "value": "K1-A113"
    }
  }, [_vm._v("K1-A113")]), _vm._v(" "), _c('el-option', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.getcookie('storeId') == '0001'),
      expression: "this.getcookie('storeId')=='0001'"
    }],
    attrs: {
      "label": "X2-A179",
      "value": "X2-A179"
    }
  }, [_vm._v("X2-A179")]), _vm._v(" "), _c('el-option', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.getcookie('storeId') == '0001'),
      expression: "this.getcookie('storeId')=='0001'"
    }],
    attrs: {
      "label": "X2-A173",
      "value": "X2-A173"
    }
  }, [_vm._v("X2-A173")])], 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "placeholder": "页面名称"
    },
    model: {
      value: (_vm.pageName),
      callback: function($$v) {
        _vm.pageName = $$v
      },
      expression: "pageName"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.secrehData()
      }
    }
  }, [_vm._v("\n            查询\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "pageName",
      "label": "页面名称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.pageName) + "  "), (scope.row.isHomePage == '1') ? _c('span', {
          staticStyle: {
            "background-color": "#3388ff",
            "color": "#fff",
            "font-size": "12px"
          }
        }, [_vm._v("店铺主页")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deviceId",
      "label": "设备编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": "创建时间",
      "formatter": _vm.formatter,
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isHomePage == '0') ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.setHomePage(scope.row)
            }
          }
        }, [_vm._v("\n                        设为主页\n                    ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.goToEditer(scope.row)
            }
          }
        }, [_vm._v("\n                        编辑\n                    ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.copyPage(scope.row)
            }
          }
        }, [_vm._v("\n                        复制\n                    ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteHomePage(scope.row)
            }
          }
        }, [_vm._v("\n                        删除\n                    ")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentpage,
      "page-count": _vm.pagesCount,
      "page-sizes": _vm.pagesizes,
      "page-size": _vm.pagesize,
      "total": _vm.pagesCount,
      "layout": " total, prev, pager, next, jumper"
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-chahange": _vm.handleSizeChange
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4bf41929!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/homePage/homePageManager.vue
// module id = 1062
// module chunks = 2